import styled, { css } from 'styled-components';
import { colorPalette, device, getSizeInPx, getSpacing, typography } from 'stylesheet';

export const LateralMenuContainer = styled.menu`
  width: ${getSpacing(10)};
  display: flex;
  flex-direction: column;
  padding: ${getSpacing(9)} 0 ${getSpacing(7)} 0;
  justify-content: space-between;
  background-color: ${colorPalette.primary};
  margin-top: 0px;
  @media (max-height: 950px) {
    height: 100%;
  }
  @media (max-width: 940px) and (max-height: 440px) {
    height: 100%;
    overflow-y: auto;
  }
  @media (max-width: 1024px) {
    padding: ${getSizeInPx(20)} 0 ${getSizeInPx(150)} 0;
  }
`;

export const LateralMenuTopContainer = styled.div``;

export const LateralMenuBottomContainer = styled.div``;
export const HamBurgerBottomContainer = styled.div`
  @media ${device.tabletMax} {
    display: none;
  }
`;

export const lateralMenuStyle = {
  itemContainer: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: inherit;
    margin-bottom: ${getSpacing(4)};
    color: ${colorPalette.grey_400};
    text-decoration: none;
    &:hover,
    &:focus {
      color: ${colorPalette.white};
      cursor: pointer;
    }
    @media (max-width: 1024px) {
      margin-bottom: ${getSpacing(2)};
    }
  `,
  itemLabel: css`
    ${typography.p1_regular};
    margin-top: ${getSpacing(1)};
    color: currentColor;
    text-align: center;
  `,
};
